import React, {useContext, useEffect, useState} from 'react';
import {UserManagement} from "#src/components/userManagement";
import CompanyTabs from "#src/components/companyTabs.js";
import {GetProductSettingsHandler, verifyPermissions} from "#src/helper/getProductSettingsHandler";
import { UserContext } from '#src/context/UserContext';
import { APIGetCompanyData} from '#src/api/companies/Companies';

export const CompanyUsers = () => {

  const { user } = useContext(UserContext);
  const [company, setCompany] = useState(null);
  const [name, setName] = useState('-');
  const [email, setEmail] = useState('-');
  const [phoneNumber, setPhoneNumber] = useState('-');
  const [addressStreet, setAddressStreet] = useState('');
  const [addressZipCode, setAddressZipCode] = useState('');
  const [addressCity, setAddressCity] = useState('');
  const [save, setSave] = useState(false);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const companyData = await APIGetCompanyData(user?.companyId);
              companyData["permissions"] = GetProductSettingsHandler(companyData?.["products"]);
        if (!companyData) {
          throw new Error('Error: Could not load company');
        }

        setCompany(companyData);
        setName(companyData.name);
        setEmail(companyData.email);
        setPhoneNumber(companyData.details.phoneNumber);
        setAddressStreet(companyData.details.address.street);
        setAddressZipCode(companyData.details.address.zipCode);
        setAddressCity(companyData.details.address.city);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (!company) {
      fetchCompanyData();
    }
  }, [company, user]);

  return (
      <div className="mx-auto max-w-7xl bg-gray-100 px-4">
        <h2 className="text-xl my-8 flex  font-semibold  leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
          Account
        </h2>
        <CompanyTabs page={"Benutzer"}/>
        <div className=" gap-x-8">
            <UserManagement company={company} limit={verifyPermissions(company, "usersMax")} userRole={user?.role}/>
        </div>
      </div>
  );
}
